import React from 'react';

const Loader = ({ size = 'medium', text, overlay = false }) => {
  const sizeClasses = {
    small: 'loader-small',
    medium: 'loader-medium',
    large: 'loader-large'
  };

  const resolvedText = text === undefined
    ? (size === 'small' ? '' : 'Loading...')
    : text;

  const LoaderContent = () => (
    <div className={`loader-container ${sizeClasses[size]}`}>
      <div className="loader-animation">
        <div className="loader-cube loader-cube-1"></div>
        <div className="loader-cube loader-cube-2"></div>
        <div className="loader-cube loader-cube-3"></div>
        <div className="loader-cube loader-cube-4"></div>
      </div>
      {resolvedText && <div className="loader-text">{resolvedText}</div>}
    </div>
  );

  if (overlay) {
    return (
      <div className="loader-overlay">
        <LoaderContent />
      </div>
    );
  }

  return <LoaderContent />;
};

export default Loader;
